module.exports = {"440117001":"街口街道","440117002":"江埔街道","440117003":"城郊街道","440117103":"温泉镇","440117104":"良口镇","440117107":"吕田镇","440117111":"太平镇","440117113":"鳌头镇","440117404":"黄龙带水库管理处","440117405":"大岭山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440117.json
// module id = 1954
// module chunks = 0